<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <div class="d-flex flex-column flex-column-fluid">
    <div class="container-fluid flex-row-fluid">
      <div class="p-6 px-8 border card">
        <ul
          class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6 nav-tabs-line"
          role="tablist"
        >
          <ng-container *ngFor="let tab of patientTabs">
            <li
              class="nav-item"
              [ngClass]="checkDisabledTab(tab.key)"
              role="presentation"
            >
              <a
                class="nav-link text-gray-800 fs-14"
                [class.active]="tab.active"
                (click)="goToOtherTab(tab.key)"
                data-bs-toggle="tab"
                [attr.href]="'#' + tab.key"
                [attr.aria-selected]="tab.active"
                tabindex="-1"
                role="tab"
              >
                <span class="me-2">{{ tab.index }}</span>
                {{ tab.label | translate }}
              </a>
            </li>
          </ng-container>
        </ul>
        <!-- Patient Information Tabs -->
        <div class="tab-content" id="myTabContent">
          <ng-container *ngFor="let tab of patientTabs">
            <div
              class="tab-pane fade"
              [class.show]="tab.active"
              [class.active]="tab.active"
              [attr.id]="tab.key"
              role="tabpanel"
              [attr.aria-labelledby]="tab.key + '-tab'"
              tabindex="0"
            >
              <ng-container [ngSwitch]="tab.key">
                <!-- New Patient Information -->
                <app-patient-information-form
                  *ngSwitchCase="'new-patient-information'"
                  [formGroup]="newPatientInformationForm"
                  [maxDate]="maxDate"
                  [newPatientId]="newPatientId"
                  [lockTckn]="!!caseId?.length"
                  (preventForbiddenCharactersEvent)="
                    preventForbiddenCharacters($event.event, $event.type)
                  "
                  (nextStepEvent)="goToOtherTab('diseases-information')"
                  (ecgFileUploadedEvent)="onEcgFileUploaded($event)"
                  (bmiCalculated)="onBMICalculated($event)"
                ></app-patient-information-form>

                <!-- Habits -->
                <app-habits-form
                  *ngSwitchCase="'habits'"
                  [formGroup]="habitsForm"
                  (nextStepEvent)="goToOtherTab('goals')"
                ></app-habits-form>

                <!-- Goals -->
                <app-goals-form
                  *ngSwitchCase="'goals'"
                  [formGroup]="goalsForm"
                  (nextStepEvent)="goToOtherTab('case-setting')"
                ></app-goals-form>

                <!-- Diseases Information -->
                <app-disease-information-form
                  *ngSwitchCase="'diseases-information'"
                  [diseasesInformationForm]="diseasesInformationForm"
                  [maxDate]="maxDate"
                  (preventForbiddenCharactersEvent)="
                    preventForbiddenCharacters($event.event, $event.type)
                  "
                  (nextStepEvent)="goToOtherTab('habits')"
                ></app-disease-information-form>

                <!-- Case Setting -->
                <app-case-setting-form
                  *ngSwitchCase="'case-setting'"
                  [caseSettingForm]="caseSettingForm"
                  (formSubmitted)="savePreparation()"
                  (nextStepEvent)="goToOtherTab('summary')">
                </app-case-setting-form>

                <!-- Summary -->
                <app-summary-form
                  *ngSwitchCase="'summary'"
                  [caseSettingForm]="caseSettingForm"
                  [diseasesInformationForm]="diseasesInformationForm"
                  [goalsForm]="goalsForm"
                  [habitsForm]="habitsForm"
                  [newPatientInformationForm]="newPatientInformationForm"
                  (formSubmitted)="savePreparation()"
                  [habitsSurvey]="habitsSurvey"
                  [omedicationTypes]="omedicationTypes"
                  >
              </app-summary-form>

              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
